import Skeleton from './Skeleton';
import TextLineSkeleton from './TextLineSkeleton';

/**
 * Card-shaped skeleton matching Bootstrap Card styling.
 * @param {number} titleWidth - Width % of title line (default 50)
 * @param {number} lines      - Body text lines (default 3)
 */
const CardSkeleton = ({ titleWidth = 50, lines = 3 }) => (
  <div className="skeleton-card">
    <Skeleton height={14} width={`${titleWidth}%`} style={{ marginBottom: 12 }} />
    <TextLineSkeleton lines={lines} />
  </div>
);

export default CardSkeleton;
